import { SettingsLoading } from '@affine/component/setting-components';
import { DocsService } from '@affine/core/modules/doc';
import { DocDisplayMetaService } from '@affine/core/modules/doc-display-meta';
import { i18nTime } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';

import type { IgnoredDoc } from '../types';
import * as styles from './styles.css';

const IgnoredDocItem = ({ doc }: { doc: IgnoredDoc }) => {
  const docDisplayService = useService(DocDisplayMetaService);
  const docService = useService(DocsService);
  const title = docDisplayService.title$(doc.docId).value;
  const DocIcon = docDisplayService.icon$(doc.docId).value;
  const record = useLiveData(docService.list.doc$(doc.docId));
  if (!record) return null;

  const { updatedDate, createDate } = record.meta$.value;
  return (
    <div
      className={styles.ignoredDoc}
      data-testid="workspace-embedding-setting-ignore-docs-list-item"
    >
      <div className={styles.docTitle}>
        <DocIcon className={styles.docIcon} />
        <span className={styles.docTitleText} data-testid="ignore-doc-title">
          {title}
        </span>
      </div>
      <div className={styles.docDates}>
        <span>
          {updatedDate ? i18nTime(updatedDate, { relative: true }) : '-'}
        </span>
        <span>
          {createDate
            ? i18nTime(createDate, {
                absolute: { accuracy: 'day', noYear: true },
              })
            : '-'}
        </span>
      </div>
    </div>
  );
};

/** The pages the search index leaves out. */
export const IgnoredDocs = ({
  ignoredDocs,
  isLoading,
}: {
  ignoredDocs: IgnoredDoc[];
  isLoading: boolean;
}) => (
  <div
    className={styles.ignoredDocs}
    data-testid="workspace-embedding-setting-ignore-docs-list"
  >
    {isLoading ? (
      <SettingsLoading />
    ) : (
      ignoredDocs.map(doc => <IgnoredDocItem key={doc.docId} doc={doc} />)
    )}
  </div>
);
